module.exports = __webpack_public_path__ + "img/english-translate-active.fe64a93e.svg";